import { Inject, Injectable } from '@angular/core';
import { ENV, IEnvironment } from 'env/config';

import { Service } from '../entity/index';
import { DataService } from '../http/dataService';
import { CentralApis } from '../interfaces/internal';
import { Role } from '../models/role.model';
import { Repository } from './repository';

@Service({
  api: 'authorization',
  model: Role,
})
@Injectable({ providedIn: 'root' })
export class AuthorizationService extends Repository<Role> {
  constructor(@Inject(ENV) env: IEnvironment, dataService: DataService) {
    super({
      client: dataService,
      url: (env.api.backend.central.endpoint as CentralApis).iam,
    });
  }

  createFromDTO(item): Role {
    return new Role(item);
  }
}
